var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ApplicationSummary',{attrs:{"application":_vm.application,"canEdit":_vm.canEdit}}),_c('ApplicationHouseholdMembers',{attrs:{"canEdit":_vm.canEdit}}),_c('ApplicationStatusHistory',{attrs:{"canEdit":_vm.canEdit}}),_c('ApplicationDocuments',{attrs:{"canEdit":_vm.canEdit}}),_c('ApplicationNotes',{attrs:{"canEdit":_vm.canEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }